<template>
  <div style="height: 100%">
    <div style="padding: 20px; height: 800px">
      <!-- 搜素框 -->
      <el-form
        :inline="true"
        :model="params"
        style="
          padding-top: 20px;
          padding-left: 20px;
          margin-bottom: 20px;
          background-color: #fff;
          border-radius: 8px;
        "
        size="small"
      >
        <el-form-item label="充电桩编号">
          <el-input v-model="params.deviceNum" placeholder="请输入充电桩编号"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="params.status" placeholder="请选择状态">
            <el-option label="未使用" value="0"></el-option>
            <el-option label="已使用" value="1"></el-option>
            <el-option label="转借中" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属类型">
          <el-select filterable v-model="params.categoryId" placeholder="请选择类型">
            <el-option
              v-for="item in classListQuery"
              :key="item.id"
              :label="item.categoryName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属公司">
          <el-select v-model="params.companyId"  filterable placeholder="请选择公司">
            <el-option
              v-for="item in companyDrownList"
              :key="item.companyId"
              :label="item.companyManager"
              :value="item.companyId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否坏桩">
          <el-select v-model="params.isBad" placeholder="请选择是否坏桩型">
            <el-option label="全部" value=""></el-option>
            <el-option label="否" value="0"></el-option>
            <el-option label="是" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否盘点">
          <el-select v-model="params.isInventory" placeholder="请选择是否盘点">
            <el-option label="全部" value="0"></el-option>
            <el-option label="否" value="-1"></el-option>
            <el-option label="是" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属区域">
          <el-select filterable v-model="params.regionId" placeholder="请选择">
            <el-option
              v-for="item in regionList"
              :key="item.id"
              :label="item.regionName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属师傅">
          <el-select
            filterable
            v-model="params.haveUser"
            placeholder="请选择"
            clearable
            @change="onQueryMasterChange"
          >
            <el-option
              v-for="item in userList"
              :key="item.id"
              :label="item.userName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分配其他">
          <el-select
            filterable
            v-model="params.otherUser"
            placeholder="请选择其他人员"
            clearable
            @change="onQueryOtherChange"
          >
            <el-option
              v-for="item in allUserList"
              :key="item.id"
              :label="item.userName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间范围">
          <el-date-picker
            style="width: 220px"
            v-model="recordTime"
            type="datetimerange"
            range-separator="至"
            value-format="timestamp"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            :default-time="['00:00:00', '23:59:59']"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="分配日期">
          <el-date-picker
            style="width: 220px"
            v-model="allocationDate"
            type="datetimerange"
            range-separator="至"
            value-format="timestamp"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            :default-time="['00:00:00', '23:59:59']"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button @click="checkData" type="primary" size="mini">查询</el-button>
          <el-button type="info" @click="reset" size="mini">重置</el-button>
          <el-button
            @click="toDayList(true)"
            type="primary"
            size="mini"
            :style="{
              border: isTodayQuery ? '3px solid #ff0000ad' : '',
              borderRadius: isTodayQuery ? '5px' : '',
            }"
            >当前账户今日分配</el-button
          >
          <!-- <el-button @click="toDayList(false)" type="primary" size="mini">今日分配</el-button> -->
        </el-form-item>
      </el-form>
      <!-- 表格 -->
      <div style="height: 100%; background-color: #fff; border-radius: 8px">
        <div style="width: 98%; margin: auto; height: 80%">
          <div style="float: right; margin: 10px 10px 15px 0">
            <el-button
              type="primary"
              size="small"
              @click="add()"
              v-show="authorization('/home-admin/device/device-manage/add')"
              >新增</el-button
            >
            <el-button
              type="primary"
              size="small"
              @click="addBatch()"
              v-show="authorization('/home-admin/device/device-manage/addBatch')"
              >批量新增</el-button
            >
            <el-button
              class="batch-region-transfer-btn"
              v-show="authorization('/home-admin/device/device-manage/batchRegionTransfer')"
              @click="batchRegionTransfer()"
              size="small"
              >批量区域调拨</el-button
            >
            <el-button
              type="success"
              v-show="authorization('/home-admin/device/device-manage/distribution')"
              @click="distribution()"
              size="small"
              >分配</el-button
            >
            <el-button
              type="success"
              v-show="authorization('/home-admin/device/device-manage/distribution')"
              @click="batchDistribution()"
              size="small"
              >批量分配</el-button
            >
            <el-button
              type="danger"
              v-show="authorization('/home-admin/device/device-manage/unDistribution')"
              @click="unDistribution()"
              size="small"
              >取消分配</el-button
            >
            <el-button
              type="danger"
              v-show="authorization('/home-admin/device/device-manage/del')"
              @click="batchDelete()"
              size="small"
              >批量删除</el-button
            >
            <el-button
              type="warning"
              v-show="authorization('/home-admin/device/device-manage/upstreamTransfer')"
              @click="batchUpstreamTransfer()"
              size="small"
              >批量上游调拨</el-button
            >
            <el-button
              type="primary"
              @click="borrow()"
              size="small"
              disabled
              v-show="authorization('/home-admin/device/device-manage/borrow')"
              >充电桩转借</el-button
            >
            <el-dropdown
              split-button
              type="warning"
              size="small"
              @click="toExcel(0)"
              @command="toExcel(1)"
              style="margin-left: 10px"
              v-loading="exportExcelLoading"
              v-show="authorization('/home-admin/device/device-manage/export')"
            >
              导出选中
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>导出全部</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <el-table
            :data="tableData"
            stripe
            size="small"
            height="90%"
            style="margin-left: 20px; width: 98%"
            :header-cell-style="{
              'background-color': '#84aace4a',
              color: '#343333',
              'text-align': 'center',
            }"
            :cell-style="{ 'text-align': 'center' }"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="45"></el-table-column>
            <el-table-column
              prop="deviceNum"
              label="充电桩编号"
              width="180"
            ></el-table-column>
            <el-table-column
              prop="categoryName"
              label="所属类型"
              width="150"
            ></el-table-column>
            <el-table-column
              prop="companyName"
              label="所属公司"
              width="150"
            ></el-table-column>
            <el-table-column
              prop="regionName"
              label="所属区域"
              width="120"
              :formatter="regionNameFormat"
            ></el-table-column>
            <!--        <el-table-column prop="sapNum" label="ASP编号"></el-table-column>-->
            <el-table-column
              prop="status"
              label="状态"
              :formatter="statusFormat"
              width="80"
            ></el-table-column>
            <!--        <el-table-column prop="describe" label="描述"></el-table-column>-->
            <el-table-column
              prop="isBad"
              label="是否坏桩"
              :formatter="isBadFormat"
              width="80"
            ></el-table-column>
            <el-table-column prop="haveUserName" label="拥有人"></el-table-column>
            <el-table-column prop="createUserName" label="录入人"></el-table-column>
            <el-table-column
              prop="createTime"
              width="150"
              label="录入时间"
              :formatter="dateFormat"
            ></el-table-column>
            <el-table-column prop="distributionUserName" label="分配人"></el-table-column>
            <el-table-column
              prop="distributionTime"
              width="150"
              label="分配时间"
              :formatter="dateFormat"
            ></el-table-column>
            <el-table-column prop="outUserName" label="使用人"></el-table-column>
            <el-table-column
              prop="useTime"
              width="150"
              label="使用时间"
              :formatter="dateFormat"
            ></el-table-column>
            <el-table-column
              prop="inventoryTime"
              width="150"
              label="盘点时间"
              :formatter="dateFormat"
            ></el-table-column>
            <el-table-column prop="imageUrl" label="盘点信息" width="160px">
              <template slot-scope="scope">
                <el-image
                  v-for="(url, index) in getImageList(scope.row.imageUrl)"
                  :key="index"
                  :src="url"
                  :preview-src-list="getImageList(scope.row.imageUrl)"
                  style="height: 20px; margin-right: 5px; float: left"
                ></el-image>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="140px" fixed="right">
              <template slot-scope="scope">
                <el-tooltip
                  effect="dark"
                  content="盘点"
                  placement="top-end"
                  v-show="authorization('/home-admin/device/device-manage/inventory')"
                >
                  <el-button
                    type="primary"
                    icon="el-icon-s-claim"
                    circle
                    size="mini"
                    @click="edit(scope.row)"
                    style="margin-right: 5px"
                  ></el-button>
                </el-tooltip>
                <el-tooltip effect="dark" content="分配历史" placement="top-end">
                  <el-button
                    type="primary"
                    content="分配历史"
                    icon="el-icon-document"
                    style="margin-left: 0px; margin-right: 5px"
                    circle
                    size="mini"
                    @click="distributeHistoryOpen(scope.row.id)"
                    v-show="authorization('/home-admin/device/device-manage/inventory')"
                  >
                  </el-button>
                </el-tooltip>
                <el-tooltip
                  effect="dark"
                  content="删除"
                  placement="top-end"
                  v-show="authorization('/home-admin/device/device-manage/del')"
                >
                  <el-popconfirm title="确认删除吗？" @confirm="deleteDevice(scope.row)">
                    <el-button
                      content="删除"
                      slot="reference"
                      type="danger"
                      icon="el-icon-delete"
                      circle
                      size="mini"
                    ></el-button>
                  </el-popconfirm>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
          <div
            style="
              padding-top: 20px;
              height: 40px;
              background-color: #fff;
              width: 100%;
              border-radius: 8px;
              text-align: right;
            "
          >
            <el-pagination
              background
              :page-sizes="sizes"
              layout="total,sizes,prev,pager,next"
              :total="total"
              @current-change="handleCurrentChange"
              @size-change="sizeChange"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>

    <!-- 弹出层 -->
    <el-dialog
      title="新增"
      :visible.sync="dialogFormAdd"
      width="700px"
      :close-on-click-modal="false"
    >
      <el-form
        :model="deviceManageArray"
        :rules="rules"
        ref="deviceManageArray"
        label-width="160px"
        size="small"
        style="width: 600px"
      >
        <el-form-item
          label="充电桩编号"
          prop="deviceNums"
          v-show="isAddBatch"
          :rules="isAddBatch ? rules.deviceNums : [{ required: false }]"
        >
          <el-input
            type="textarea"
            :rows="4"
            v-model="deviceManageArray.deviceNums"
            placeholder="请输入充电桩编号,多个以换行隔开"
          ></el-input>
        </el-form-item>
        <el-form-item label="充电桩编号" prop="deviceNum" v-show="!isAddBatch">
          <el-input v-model="deviceManageArray.deviceNum" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item
          label="充电桩数量"
          prop="count"
          v-show="
            (deviceManageArray.deviceNum == null || deviceManageArray.deviceNum == '') &&
            !isAddBatch
          "
        >
          <el-input v-model="deviceManageArray.count" type="number"></el-input>
        </el-form-item>
        <el-form-item label="所属类型" prop="categoryId">
          <el-select
            v-model="deviceManageArray.categoryId"
            placeholder="请选择类型"
            style="width: 100%"
            filterable
            @change="onDeviceCategoryChange"
          >
            <el-option
              v-for="item in classList"
              :key="item.id"
              :label="item.categoryName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属公司" prop="companyId">
          <el-select
            filterable
            v-model="deviceManageArray.companyId"
            placeholder="请选择所属公司"
            style="width: 100%"
          >
            <el-option
              v-for="item in companyDrownList"
              :key="item.companyId"
              :label="item.companyManager"
              :value="item.companyId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="所属区域"
          prop="regionId"
          required
        >
          <el-select
            filterable
            v-model="deviceManageArray.regionId"
            placeholder="请选择区域（必填）"
            style="width: 100%"
          >
            <el-option
              v-for="item in regionListForm"
              :key="item.id"
              :label="item.regionName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="所属师傅"
          v-show="!authorization('/device-data-manager-addForMe') && authorization('/home-admin/device/device-manage/add-select-master')"
        >
          <el-select
            filterable
            v-model="deviceManageArray.haveUser"
            placeholder="请选择所属师傅"
            style="width: 100%"
          >
            <el-option
              v-for="item in userList"
              :key="item.id"
              :label="item.userName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" style="margin-top: 50px">
        <el-button @click="dialogFormAdd = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="addClick('deviceManageArray')" size="mini"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 编辑弹出层 -->
    <el-dialog
      title="充电桩盘点"
      :visible.sync="dialogFormEdit"
      width="700px"
      :close-on-click-modal="false"
    >
      <el-form
        :model="deviceManageArray"
        :rules="editRules"
        ref="deviceManageArrayEdit"
        label-width="160px"
        size="small"
        style="width: 600px"
      >
        <el-form-item label="所属类型" prop="categoryId">
          <el-select
            disabled
            v-model="deviceManageArray.categoryId"
            placeholder="请选择类型"
            style="width: 100%"
            filterable
          >
            <el-option
              v-for="item in classList"
              :key="item.id"
              :label="item.categoryName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属公司" prop="companyId">
          <el-select
            filterable
            v-model="deviceManageArray.companyId"
            placeholder="请选择所属公司"
            style="width: 100%"
          >
            <el-option
              v-for="item in companyDrownList"
              :key="item.companyId"
              :label="item.companyManager"
              :value="item.companyId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="所属区域"
          prop="regionId"
        >
          <el-select
            filterable
            v-model="deviceManageArray.regionId"
            placeholder="请选择区域"
            style="width: 100%"
          >
            <el-option
              v-for="item in regionListForm"
              :key="item.id"
              :label="item.regionName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="充电桩编号" prop="deviceNum">
          <el-input
            v-model="deviceManageArray.deviceNum"
            autocomplete="off"
            :disabled="
              !authorization('/home-admin/device/device-manage/inventory-deviceid')
            "
          ></el-input>
        </el-form-item>
        <el-form-item
          label="使用状态"
          prop="status"
          v-show="authorization('/home-admin/device/device-manage/inventory-status')"
        >
          <template>
            <el-radio v-model="deviceManageArray.status" :label="0">未使用</el-radio>
            <el-radio v-model="deviceManageArray.status" :label="1">已使用</el-radio>
          </template>
        </el-form-item>
        <el-form-item label="是否坏桩" prop="isBad">
          <template>
            <el-radio v-model="deviceManageArray.isBad" :label="0">否</el-radio>
            <el-radio v-model="deviceManageArray.isBad" :label="1">是</el-radio>
          </template>
        </el-form-item>
        <el-form-item label="充电桩图片">
          <el-upload
            action="#"
            accept="image/jpeg,image/png,image/tiff,image/vnd.svf"
            :file-list="deviceManageArray.imageList"
            list-type="picture-card"
            :auto-upload="false"
            :on-change="(file, fileList) => upload(file, fileList)"
            :on-remove="commRemove"
            :on-preview="handlePictureCardPreview"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            type="textarea"
            :rows="4"
            v-model="deviceManageArray.describe"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" style="margin-top: 50px">
        <el-button @click="dialogFormEdit = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="editSubMit('deviceManageArrayEdit')" size="mini"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="分配"
      :visible.sync="dialogFormDistribution"
      width="700px"
      :close-on-click-modal="false"
    >
      <el-form
        :model="deviceManageArray"
        :rules="rules"
        ref="deviceManageArray"
        label-width="160px"
        size="small"
        style="width: 600px"
      >
        <el-form-item
          label="充电桩类型"
          prop="categoryId"
          :rules="
            deviceManageArray.selectDeviceList == null ||
            deviceManageArray.selectDeviceList.length <= 0
              ? rules.categoryId
              : [{ required: false }]
          "
          v-show="
            deviceManageArray.selectDeviceList == null ||
            deviceManageArray.selectDeviceList.length <= 0
          "
        >
          <el-select
            v-model="deviceManageArray.categoryId"
            placeholder="请选择"
            style="width: 100%"
            filterable
          >
            <el-option
              v-for="item in classList"
              :key="item.id"
              :label="item.categoryName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="充电桩数量"
          prop="count"
          :rules="
            deviceManageArray.selectDeviceList == null ||
            deviceManageArray.selectDeviceList.length <= 0
              ? rules.count
              : [{ required: false }]
          "
          v-show="
            deviceManageArray.selectDeviceList == null ||
            deviceManageArray.selectDeviceList.length <= 0
          "
        >
          <el-input
            type="number"
            v-model="deviceManageArray.count"
            placeholder="请输入"
            style="width: 100%"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="所属区域"
          prop="regionId"
          :rules="
            deviceManageArray.selectDeviceList == null ||
            deviceManageArray.selectDeviceList.length <= 0
              ? rules.regionId
              : [{ required: false }]
          "
          v-show="
            deviceManageArray.selectDeviceList == null ||
            deviceManageArray.selectDeviceList.length <= 0
          "
        >
          <el-select
            filterable
            v-model="deviceManageArray.regionId"
            placeholder="请选择区域"
            style="width: 100%"
          >
            <el-option
              v-for="item in regionListForm"
              :key="item.id"
              :label="item.regionName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="负责师傅"
          prop="haveUser"
          :rules="assignUserRules"
        >
          <el-select
            filterable
            v-model="deviceManageArray.haveUser"
            placeholder="请选择负责师傅"
            style="width: 100%"
            clearable
            @change="onAssignMasterChange"
          >
            <el-option
              v-for="item in sortedA"
              :key="item.id"
              :label="item.userName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="分配其他"
          prop="otherUser"
          :rules="assignUserRules"
        >
          <el-select
            filterable
            v-model="deviceManageArray.otherUser"
            placeholder="请选择其他人员"
            style="width: 100%"
            clearable
            @change="onAssignOtherChange"
          >
            <el-option
              v-for="item in allUserList"
              :key="item.id"
              :label="item.userName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" style="margin-top: 50px">
        <el-button @click="dialogFormDistribution = false" size="mini">取 消</el-button>
        <el-button
          type="primary"
          @click="distributionSubMit('deviceManageArray')"
          size="mini"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    
    <el-dialog
      title="批量分配"
      :visible.sync="dialogFormBatchDistribution"
      width="75vw"
      :close-on-click-modal="false"
    >
      <div style="padding: 20px;max-height: 60vh; display: flex; flex-direction: column; overflow-y: auto;">
        <!-- 充电桩编号输入区域 -->
        <el-form :inline="true" size="small" style="margin-bottom: 20px;">
          <el-form-item label="充电桩编号:"  style="width: 100%;">
            <el-input
              type="textarea"
              :rows="3"
              v-model="batchDeviceNums"
              placeholder="请输入充电桩编号,多个空格隔开"
              style="width: 62vw"
              clearable
            ></el-input>
             <el-button 
               type="primary" 
               @click="queryBatchDevices" 
               size="small"
               style="margin-left: 10px;"
             >查询</el-button>
             <el-button 
               type="info" 
               @click="clearBatchData" 
               size="small"
               style="margin-left: 10px;"
             >清空</el-button>
             
           </el-form-item>
        </el-form>
        
        <!-- 查询结果表格区域 -->
         <div style="flex: 1; border: 1px solid #dcdfe6; border-radius: 4px;">
      <el-table
             :data="batchQueryResults"
             stripe
             size="small"
             height="35vh"
             :header-cell-style="{
               'background-color': '#84aace4a',
               color: '#343333',
               'text-align': 'center',
             }"
             :cell-style="{ 'text-align': 'center' }"
             v-loading="queryBatchLoading"
           >
            <el-table-column
              prop="deviceNum"
              label="充电桩编号"
              width="180"
            ></el-table-column>
            <el-table-column
              prop="categoryName"
              label="所属类型"
              width="150"
            ></el-table-column>
            <el-table-column
              prop="companyName"
              label="所属公司"
              width="150"
            ></el-table-column>
            <el-table-column
              prop="regionName"
              label="所属区域"
              width="120"
              :formatter="regionNameFormat"
            ></el-table-column>
            <el-table-column
              prop="status"
              label="状态"
              :formatter="statusFormat"
              width="80"
            ></el-table-column>
            <el-table-column
              prop="isBad"
              label="是否坏桩"
              :formatter="isBadFormat"
              width="80"
            ></el-table-column>
            <el-table-column prop="haveUserName" label="拥有人"></el-table-column>
            <el-table-column prop="createUserName" label="录入人"></el-table-column>
            <el-table-column
              prop="createTime"
              width="150"
              label="录入时间"
              :formatter="dateFormat"
            ></el-table-column>
      </el-table>
        </div>
      </div>
      
      <div slot="footer" style="margin-top: 20px">
        <el-button @click="dialogFormBatchDistribution = false" size="mini">取 消</el-button>
        <el-button
          type="primary"
          @click="confirmBatchDistribution"
          size="mini"
          :disabled="batchQueryResults.length === 0"
          >确认分配</el-button
        >
        <el-button
          type="danger"
          @click="removeUsedDevices"
          size="mini"
          :disabled="batchQueryResults.filter(item => item.status === 1).length === 0"
          >一键删除已使用</el-button
        >
      </div>
    </el-dialog>
    
    <!-- 批量分配确认弹窗 -->
    <el-dialog
      title="选择负责师傅"
      :visible.sync="dialogBatchConfirmDistribution"
      width="500px"
      :close-on-click-modal="false"
    >
      <el-form
        :model="batchConfirmForm"
        :rules="batchConfirmRules"
        ref="batchConfirmForm"
        label-width="120px"
        size="small"
      >
        <el-form-item label="负责师傅" prop="masterUserId">
          <el-select
            filterable
            v-model="batchConfirmForm.masterUserId"
            placeholder="请选择负责师傅"
            style="width: 100%"
            clearable
            @change="onBatchMasterChange"
          >
            <el-option
              v-for="item in sortedA"
              :key="item.id"
              :label="item.userName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分配其他" prop="otherUserId">
          <el-select
            filterable
            v-model="batchConfirmForm.otherUserId"
            placeholder="请选择其他人员"
            style="width: 100%"
            clearable
            @change="onBatchOtherChange"
          >
            <el-option
              v-for="item in allUserList"
              :key="item.id"
              :label="item.userName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      
      <div slot="footer" style="margin-top: 20px">
        <el-button @click="dialogBatchConfirmDistribution = false" size="mini">取 消</el-button>
        <el-button
          type="primary"
          @click="executeBatchDistribution"
          size="mini"
          :loading="batchDistributionLoading"
          >确定分配</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="批量区域调拨"
      :visible.sync="dialogFormBatchRegionTransfer"
      width="75vw"
      :close-on-click-modal="false"
    >
      <div style="padding: 20px;max-height: 60vh; display: flex; flex-direction: column; overflow-y: auto;">
        <el-form :inline="true" size="small" style="margin-bottom: 20px;">
          <el-form-item label="充电桩编号:" style="width: 100%;">
            <el-input
              type="textarea"
              :rows="3"
              v-model="batchRegionTransferDeviceNums"
              placeholder="请输入充电桩编号,多个空格隔开"
              style="width: 62vw"
              clearable
            ></el-input>
            <el-button
              type="primary"
              @click="queryBatchRegionTransferDevices"
              size="small"
              style="margin-left: 10px;"
            >查询</el-button>
            <el-button
              type="info"
              @click="clearBatchRegionTransferData"
              size="small"
              style="margin-left: 10px;"
            >清空</el-button>
          </el-form-item>
        </el-form>

        <div style="flex: 1; border: 1px solid #dcdfe6; border-radius: 4px;">
          <el-table
            :data="batchRegionTransferQueryResults"
            stripe
            size="small"
            height="35vh"
            :header-cell-style="{
              'background-color': '#84aace4a',
              color: '#343333',
              'text-align': 'center',
            }"
            :cell-style="{ 'text-align': 'center' }"
            v-loading="queryBatchRegionTransferLoading"
          >
            <el-table-column
              prop="deviceNum"
              label="充电桩编号"
              width="180"
            ></el-table-column>
            <el-table-column
              prop="categoryName"
              label="所属类型"
              width="150"
            ></el-table-column>
            <el-table-column
              prop="companyName"
              label="所属公司"
              width="150"
            ></el-table-column>
            <el-table-column
              prop="regionName"
              label="所属区域"
              width="120"
              :formatter="regionNameFormat"
            ></el-table-column>
            <el-table-column
              prop="status"
              label="状态"
              :formatter="statusFormat"
              width="80"
            ></el-table-column>
            <el-table-column
              prop="isBad"
              label="是否坏桩"
              :formatter="isBadFormat"
              width="80"
            ></el-table-column>
            <el-table-column prop="haveUserName" label="拥有人"></el-table-column>
            <el-table-column prop="createUserName" label="录入人"></el-table-column>
            <el-table-column
              prop="createTime"
              width="150"
              label="录入时间"
              :formatter="dateFormat"
            ></el-table-column>
          </el-table>
        </div>
      </div>

      <div slot="footer" style="margin-top: 20px">
        <el-button @click="dialogFormBatchRegionTransfer = false" size="mini">取 消</el-button>
        <el-button
          type="primary"
          @click="confirmBatchRegionTransfer"
          size="mini"
          :disabled="batchRegionTransferQueryResults.length === 0"
        >确认调拨</el-button>
        <el-button
          type="danger"
          @click="removeRegionTransferUsedDevices"
          size="mini"
          :disabled="batchRegionTransferQueryResults.filter(item => item.status === 1).length === 0"
        >一键删除已使用</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="确认区域调拨"
      :visible.sync="dialogBatchConfirmRegionTransfer"
      width="500px"
      :close-on-click-modal="false"
    >
      <el-form
        :model="batchRegionTransferConfirmForm"
        :rules="batchRegionTransferConfirmRules"
        ref="batchRegionTransferConfirmForm"
        label-width="120px"
        size="small"
      >
        <el-form-item label="目标区域" prop="regionId">
          <el-select
            filterable
            v-model="batchRegionTransferConfirmForm.regionId"
            placeholder="请选择区域"
            style="width: 100%"
          >
            <el-option
              v-for="item in regionListForm"
              :key="item.id"
              :label="item.regionName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="负责师傅" prop="masterUserId">
          <el-select
            filterable
            clearable
            v-model="batchRegionTransferConfirmForm.masterUserId"
            placeholder="请选择负责师傅（选填）"
            style="width: 100%"
            @change="onRegionTransferMasterChange"
          >
            <el-option
              v-for="item in sortedA"
              :key="item.id"
              :label="item.userName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分配其他" prop="otherUserId">
          <el-select
            filterable
            clearable
            v-model="batchRegionTransferConfirmForm.otherUserId"
            placeholder="请选择其他人员（选填）"
            style="width: 100%"
            @change="onRegionTransferOtherChange"
          >
            <el-option
              v-for="item in allUserList"
              :key="item.id"
              :label="item.userName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <div slot="footer" style="margin-top: 20px">
        <el-button @click="dialogBatchConfirmRegionTransfer = false" size="mini">取 消</el-button>
        <el-button
          type="primary"
          @click="executeBatchRegionTransfer"
          size="mini"
          :loading="batchRegionTransferLoading"
        >确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="批量删除"
      :visible.sync="dialogFormBatchDelete"
      width="75vw"
      :close-on-click-modal="false"
    >
      <div style="padding: 20px;max-height: 60vh; display: flex; flex-direction: column; overflow-y: auto;">
        <el-form :inline="true" size="small" style="margin-bottom: 20px;">
          <el-form-item label="充电桩编号:" style="width: 100%;">
            <el-input
              type="textarea"
              :rows="3"
              v-model="batchDeleteDeviceNums"
              placeholder="请输入充电桩编号，支持逗号、空格或换行分隔"
              style="width: 62vw"
              clearable
            ></el-input>
            <el-button
              type="primary"
              @click="queryBatchDeleteDevices"
              size="small"
              style="margin-left: 10px;"
            >查询</el-button>
            <el-button
              type="info"
              @click="clearBatchDeleteData"
              size="small"
              style="margin-left: 10px;"
            >清空</el-button>
          </el-form-item>
        </el-form>

        <div style="flex: 1; border: 1px solid #dcdfe6; border-radius: 4px;">
          <el-table
            :data="batchDeleteQueryResults"
            stripe
            size="small"
            height="35vh"
            :header-cell-style="{
              'background-color': '#84aace4a',
              color: '#343333',
              'text-align': 'center',
            }"
            :cell-style="{ 'text-align': 'center' }"
            v-loading="queryBatchDeleteLoading"
          >
            <el-table-column
              prop="deviceNum"
              label="充电桩编号"
              width="180"
            ></el-table-column>
            <el-table-column
              prop="categoryName"
              label="所属类型"
              width="150"
            ></el-table-column>
            <el-table-column
              prop="companyName"
              label="所属公司"
              width="150"
            ></el-table-column>
            <el-table-column
              prop="regionName"
              label="所属区域"
              width="120"
              :formatter="regionNameFormat"
            ></el-table-column>
            <el-table-column
              prop="status"
              label="状态"
              :formatter="statusFormat"
              width="80"
            ></el-table-column>
            <el-table-column
              prop="isBad"
              label="是否坏桩"
              :formatter="isBadFormat"
              width="80"
            ></el-table-column>
            <el-table-column prop="haveUserName" label="拥有人"></el-table-column>
            <el-table-column prop="createUserName" label="录入人"></el-table-column>
            <el-table-column
              prop="createTime"
              width="150"
              label="录入时间"
              :formatter="dateFormat"
            ></el-table-column>
          </el-table>
        </div>
      </div>

      <div slot="footer" style="margin-top: 20px">
        <el-button @click="dialogFormBatchDelete = false" size="mini">取 消</el-button>
        <el-button
          type="danger"
          @click="confirmBatchDelete"
          size="mini"
          :loading="batchDeleteLoading"
          :disabled="batchDeleteQueryResults.length === 0"
        >确认删除</el-button>
        <el-button
          type="warning"
          @click="removeBatchDeleteUnavailableDevices"
          size="mini"
          :disabled="batchDeleteQueryResults.filter(item => item.status === 1 || item.status === 2).length === 0"
        >一键移除不可删除</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="批量上游调拨"
      :visible.sync="dialogFormBatchUpstreamTransfer"
      width="75vw"
      :close-on-click-modal="false"
      @close="clearBatchUpstreamTransferForm"
    >
      <div style="padding: 20px;max-height: 65vh; display: flex; flex-direction: column; overflow-y: auto;">
        <el-form :inline="true" size="small" style="margin-bottom: 20px;">
          <el-form-item label="充电桩编号:" style="width: 100%;">
            <el-input
              type="textarea"
              :rows="3"
              v-model="batchUpstreamTransferDeviceNums"
              placeholder="请输入充电桩编号，支持逗号、空格或换行分隔"
              style="width: 62vw"
              clearable
            ></el-input>
            <el-button
              type="primary"
              @click="queryBatchUpstreamTransferDevices"
              size="small"
              style="margin-left: 10px;"
            >查询</el-button>
            <el-button
              type="info"
              @click="clearBatchUpstreamTransferData"
              size="small"
              style="margin-left: 10px;"
            >清空</el-button>
          </el-form-item>
        </el-form>

        <div style="flex: 1; border: 1px solid #dcdfe6; border-radius: 4px;">
          <el-table
            :data="batchUpstreamTransferQueryResults"
            stripe
            size="small"
            height="30vh"
            :header-cell-style="{
              'background-color': '#84aace4a',
              color: '#343333',
              'text-align': 'center',
            }"
            :cell-style="{ 'text-align': 'center' }"
            v-loading="queryBatchUpstreamTransferLoading"
          >
            <el-table-column prop="deviceNum" label="充电桩编号" width="180"></el-table-column>
            <el-table-column prop="categoryName" label="所属类型" width="150"></el-table-column>
            <el-table-column prop="companyName" label="所属公司" width="150"></el-table-column>
            <el-table-column
              prop="regionName"
              label="所属区域"
              width="120"
              :formatter="regionNameFormat"
            ></el-table-column>
            <el-table-column prop="status" label="状态" :formatter="statusFormat" width="80"></el-table-column>
            <el-table-column prop="isBad" label="是否坏桩" :formatter="isBadFormat" width="80"></el-table-column>
            <el-table-column prop="haveUserName" label="拥有人"></el-table-column>
            <el-table-column prop="createUserName" label="录入人"></el-table-column>
            <el-table-column prop="createTime" width="150" label="录入时间" :formatter="dateFormat"></el-table-column>
          </el-table>
        </div>

        <el-form
          ref="batchUpstreamTransferForm"
          :model="batchUpstreamTransferForm"
          :rules="batchUpstreamTransferRules"
          label-width="90px"
          size="small"
          style="margin-top: 20px;"
        >
          <el-form-item label="调拨备注" prop="remark">
            <el-input
              type="textarea"
              :rows="3"
              v-model="batchUpstreamTransferForm.remark"
              placeholder="请输入调拨备注（必填）"
              maxlength="500"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item label="附件">
            <UpLoad
              :fileSize="100"
              ref="upstreamTransferUploadRefs"
              :limit="20"
              @remove="removeUpstreamTransferFile"
              @uploadSuccess="handleUpstreamTransferUploadSuccess"
            ></UpLoad>
          </el-form-item>
        </el-form>
      </div>

      <div slot="footer" style="margin-top: 20px">
        <el-button @click="dialogFormBatchUpstreamTransfer = false" size="mini">取 消</el-button>
        <el-button
          type="warning"
          @click="confirmBatchUpstreamTransfer"
          size="mini"
          :loading="batchUpstreamTransferLoading"
          :disabled="batchUpstreamTransferQueryResults.length === 0"
        >确认调拨</el-button>
        <el-button
          type="info"
          @click="removeBatchUpstreamTransferUnavailableDevices"
          size="mini"
          :disabled="batchUpstreamTransferQueryResults.filter(item => item.status === 1 || item.status === 2).length === 0"
        >一键移除不可调拨</el-button>
      </div>
    </el-dialog>
    
    <el-dialog
      title="充电桩转借"
      :visible.sync="dialogFormBorrow"
      width="700px"
      :close-on-click-modal="false"
    >
      <el-form
        :model="deviceManageBorrow"
        :rules="rules1"
        ref="deviceManageBorrow"
        label-width="160px"
        size="small"
        style="width: 600px"
      >
        <el-form-item label="借给谁" prop="inputUser">
          <el-select
            filterable
            v-model="deviceManageBorrow.inputUser"
            placeholder="请选择"
            style="width: 100%"
          >
            <el-option
              v-for="item in userList"
              :key="item.id"
              :label="item.userName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="充电桩编号" prop="deviceIds">
          <el-select
            v-model="deviceManageBorrow.deviceIds"
            filterable
            multiple
            placeholder="请选择"
            style="width: 100%"
          >
            <el-option
              v-for="item in changeDeviceList"
              :key="item.id"
              :label="item.deviceNum + '(' + item.categoryName + ')'"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="充电桩类型"
          prop="categoryId"
          v-show="
            deviceManageBorrow.deviceIds == null ||
            deviceManageBorrow.deviceIds.length <= 0
          "
          :rules="
            deviceManageBorrow.deviceIds == null ||
            deviceManageBorrow.deviceIds.length <= 0
              ? rules.categoryId
              : [{ required: false }]
          "
        >
          <el-select
            v-model="deviceManageBorrow.categoryId"
            placeholder="请选择"
            style="width: 100%"
          >
            <el-option
              v-for="item in classList"
              :key="item.id"
              :label="item.categoryName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="充电桩数量"
          prop="count"
          v-show="
            deviceManageBorrow.deviceIds == null ||
            deviceManageBorrow.deviceIds.length <= 0
          "
          :rules="
            deviceManageBorrow.deviceIds == null ||
            deviceManageBorrow.deviceIds.length <= 0
              ? rules.count
              : [{ required: false }]
          "
        >
          <el-input
            type="number"
            v-model="deviceManageBorrow.count"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" style="margin-top: 50px">
        <el-button @click="dialogFormBorrow = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="borrowSubMit('deviceManageBorrow')" size="mini"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogImagePreview">
      <img width="100%" :src="imagePreviewUrl" alt="" />
    </el-dialog>
    <!-- 驳回历史 -->
    <DistributeHistory ref="distributeHistory" />
  </div>
</template>

<script>
import moment from "moment";
import { authorization } from "../../../authorization/authorization";
import ImageCompressor from "compressorjs";
import DistributeHistory from "@/components/admin/device/components/DistributeHistory";
import UpLoad from "@/components/UpLoad";
import { getBData } from "@/utils/storage.js";
import { saveUserSortSimple } from "@/utils/userSort.js";
const STORE_KEY = "deviceUserSort";
export default {
  components: { DistributeHistory, UpLoad },
  data() {
    return {
      sortUserList: [],
      recordTime: [],
      allocationDate:[],
      regionList: [],
      regionListForm: [],
      companyDrownList: [],
      exportExcelLoading: false,
      input: "",
      dialogFormAdd: false,
      dialogFormEdit: false,
      isAddBatch: false,
      dialogImagePreview: false,
      imagePreviewUrl: "",
      tableData: [],
      dialogFormBatchDistribution: false,
      dialogBatchConfirmDistribution: false,
      batchDistributionLoading: false,
      queryBatchLoading: false,
      batchDeviceNums: "",
      batchQueryResults: [],
      batchConfirmForm: {
        masterUserId: "",
        otherUserId: "",
      },
      dialogFormBatchRegionTransfer: false,
      dialogBatchConfirmRegionTransfer: false,
      batchRegionTransferLoading: false,
      queryBatchRegionTransferLoading: false,
      batchRegionTransferDeviceNums: "",
      batchRegionTransferQueryResults: [],
      batchRegionTransferConfirmForm: {
        regionId: undefined,
        masterUserId: "",
        otherUserId: "",
      },
      batchRegionTransferConfirmRules: {
        regionId: [
          { required: true, message: "请选择区域", trigger: ["change", "blur"] }
        ]
      },
      dialogFormBatchDelete: false,
      batchDeleteLoading: false,
      queryBatchDeleteLoading: false,
      batchDeleteDeviceNums: "",
      batchDeleteQueryResults: [],
      dialogFormBatchUpstreamTransfer: false,
      batchUpstreamTransferLoading: false,
      queryBatchUpstreamTransferLoading: false,
      batchUpstreamTransferDeviceNums: "",
      batchUpstreamTransferQueryResults: [],
      batchUpstreamTransferForm: {
        remark: "",
        attachmentIds: [],
      },
      batchUpstreamTransferRules: {
        remark: [{ required: true, message: "请输入调拨备注", trigger: "blur" }],
      },
      params: {
        deviceNum: "",
        brand: "",
        sapNum: "",
        status: "",
        categoryId: "",
        beginTime: "",
        endTime: "",
        regionId: "",
        haveUser: "",
        otherUser: "",
        page: 1,
        size: 10,
      },
      deviceManageBorrow: {
        count: "",
        categoryId: "",
      },
      deviceManageArray: {
        id: "",
        deviceNum: "",
        brand: "",
        sapNum: "",
        describe: "",
        haveUser: "",
        otherUser: "",
        categoryId: "",
        inputUser: "",
        count: "",
        deviceIdList: [],
        imageList: [],
        regionId: undefined,
      },
      rules: {
        count: [{ required: true, message: "请输入数量", trigger: "blur" }],
        categoryId: [{ required: true, message: "请选择类型", trigger: "blur" }],
        deviceNums: [{ required: true, message: "请输入充电桩编号", trigger: "blur" }],
        companyId: [{ required: true, message: "请选择所属公司", trigger: "blur" }],
        regionId: [
          { required: true, message: "请选择区域", trigger: ["change", "blur"] },
        ],
      },
      editRules: {
        regionId: [
          { required: true, message: "请选择区域", trigger: ["change", "blur"] },
        ],
      },
      rules1: {
        haveUser: [{ required: true, message: "请选择所属师傅", trigger: "blur" }],
        inputUser: [{ required: true, message: "请选择转借给谁", trigger: "blur" }],
        categoryId: [{ required: true, message: "请选择类型", trigger: "blur" }],
      },
      orderIdList: [],
      userList: [],
      allUserList: [],
      dialogFormDistribution: false,
      dialogFormBorrow: false,
      total: 0,
      sizes: [10, 15],
      classListQuery: [],
      classList: [],
      changeDeviceList: [],
      multipleSelection: [],
      isTodayQuery:false
    };
  },
  computed: {
    assignUserRules() {
      return [
        {
          validator: (rule, value, callback) => {
            const { haveUser, otherUser } = this.deviceManageArray;
            if (!haveUser && !otherUser) {
              callback(new Error("请选择负责师傅或分配其他"));
              return;
            }
            if (haveUser && otherUser) {
              callback(new Error("负责师傅与分配其他只能选一个"));
              return;
            }
            callback();
          },
          trigger: "change",
        },
      ];
    },
    batchConfirmRules() {
      return {
        masterUserId: [
          {
            validator: (rule, value, callback) => {
              const { masterUserId, otherUserId } = this.batchConfirmForm;
              if (!masterUserId && !otherUserId) {
                callback(new Error("请选择负责师傅或分配其他"));
                return;
              }
              if (masterUserId && otherUserId) {
                callback(new Error("负责师傅与分配其他只能选一个"));
                return;
              }
              callback();
            },
            trigger: "change",
          },
        ],
        otherUserId: [
          {
            validator: (rule, value, callback) => {
              const { masterUserId, otherUserId } = this.batchConfirmForm;
              if (!masterUserId && !otherUserId) {
                callback(new Error("请选择负责师傅或分配其他"));
                return;
              }
              if (masterUserId && otherUserId) {
                callback(new Error("负责师傅与分配其他只能选一个"));
                return;
              }
              callback();
            },
            trigger: "change",
          },
        ],
      };
    },
    // 计算属性，按照 b 数组根据 a 数组顺序排序
    sortedA() {
      const indexMap = new Map(this.sortUserList.map((id, index) => [id, index]));
      return [...this.userList].sort((itemA, itemB) => {
        const indexA = indexMap.get(itemA.id);
        const indexB = indexMap.get(itemB.id);

        // 处理 indexA 和 indexB 为空的情况
        if (indexA === undefined && indexB === undefined) {
          return 0; // 如果两个都不存在，保持原有顺序
        } else if (indexA === undefined) {
          return 1; // itemA 不在 indexMap 中，排在后面
        } else if (indexB === undefined) {
          return -1; // itemB 不在 indexMap 中，排在后面
        }

        return indexB - indexA; // 排序逻辑
      });
    },
  },
  created() {
    this.queryDeviceManageList();
    this.queryUserList();
    this.queryAllUserList();
    this.queryClassList();
    this.queryRegionList();
    this.getCompanyDrown();
  },
  mounted() {
    this.sortUserList = getBData(STORE_KEY);
  },
  methods: {
    distributeHistoryOpen(id) {
      this.$refs.distributeHistory.open(id);
    },
    authorization,
    resolveAssignUserId(masterUserId, otherUserId) {
      if (masterUserId && otherUserId) {
        return null;
      }
      return masterUserId || otherUserId || null;
    },
    onAssignMasterChange(value) {
      if (value) {
        this.deviceManageArray.otherUser = "";
      }
    },
    onAssignOtherChange(value) {
      if (value) {
        this.deviceManageArray.haveUser = "";
      }
    },
    onBatchMasterChange(value) {
      if (value) {
        this.batchConfirmForm.otherUserId = "";
      }
    },
    onBatchOtherChange(value) {
      if (value) {
        this.batchConfirmForm.masterUserId = "";
      }
    },
    onRegionTransferMasterChange(value) {
      if (value) {
        this.batchRegionTransferConfirmForm.otherUserId = "";
      }
    },
    onRegionTransferOtherChange(value) {
      if (value) {
        this.batchRegionTransferConfirmForm.masterUserId = "";
      }
    },
    onQueryMasterChange(value) {
      if (value) {
        this.params.otherUser = "";
      }
    },
    onQueryOtherChange(value) {
      if (value) {
        this.params.haveUser = "";
      }
    },
    buildQueryParams(extraParams) {
      const queryParams = { ...(extraParams || this.params) };
      if (this.recordTime.length > 0) {
        queryParams.beginTime = this.recordTime[0];
        if (this.recordTime.length > 1) {
          queryParams.endTime = this.recordTime[1];
        }
      }
      if (this.allocationDate.length > 0) {
        queryParams.beginDistributionTime = this.allocationDate[0];
        if (this.allocationDate.length > 1) {
          queryParams.endDistributionTime = this.allocationDate[1];
        }
      }
      if (queryParams.haveUser && queryParams.otherUser) {
        return null;
      }
      const assignUserId = this.resolveAssignUserId(
        queryParams.haveUser,
        queryParams.otherUser
      );
      queryParams.haveUser = assignUserId || "";
      delete queryParams.otherUser;
      return queryParams;
    },
    getCompanyDrown() {
      this.axios({
        method: "get",
        url: "/v1/web/company-manager/select-company-drown",
      }).then((res) => {
        this.companyDrownList = res.data.data;
      });
    },
    onDeviceCategoryChange() {
      this.$nextTick(() => {
        if (this.$refs.deviceManageArray) {
          this.$refs.deviceManageArray.clearValidate("regionId");
        }
      });
    },
    queryRegionList() {
      this.axios({
        method: "get",
        url: "/v1/web/region-manage/select-region-for-device-form",
      }).then((res) => {
        const list = res.data.data.list || [];
        this.regionListForm = list;
        this.regionList = [];
        let obj = {};
        obj.id = 0;
        obj.regionName = "全部";
        this.regionList.push(obj);
        this.regionList.push(...list);
      });
    },
    toExcel(exportType) {
      this.exportExcelLoading = true;
      const queryParams = this.buildQueryParams();
      if (!queryParams) {
        this.exportExcelLoading = false;
        this.$message.error("所属师傅与分配其他只能选一个");
        return;
      }
      let params = { ...queryParams };
      if (exportType == 0) {
        if (this.multipleSelection.length <= 0) {
          this.$message({ message: "请至少勾选一个订单项", type: "error" });
          return;
        }

        this.deviceIds = [];
        for (let i = 0; i < this.multipleSelection.length; i++) {
          this.deviceIds.push(this.multipleSelection[i].id);
        }
        params.deviceIds = this.deviceIds;
      } else {
        params.deviceIds = [];
      }

      this.axios({
        method: "post",
        url: "/v1/web/device-manage/device-export-excel",
        data: params,
        responseType: "blob",
      }).then((res) => {
        let filename = res.headers["content-disposition"];
        const link = document.createElement("a");
        let blob = new Blob([res.data], { type: "application/octet-stream" }); //类型excel
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        link.setAttribute(
          "download",
          decodeURI(filename.substring(filename.indexOf("=") + 1))
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.exportExcelLoading = false;
      });
    },
    getDeviceByCategory() {
      this.axios({
        method: "get",
        url: "/v1/web/device-manage/list-device-manage",
        params: {
          status: 0,
          numNotNull: "true",
        },
      }).then((res) => {
        this.changeDeviceList = res.data.data.list;
      });
    },
    queryClassList() {
      this.axios({
        method: "get",
        url: "/v1/web/device-category/select-category",
      }).then((res) => {
        let obj = {};
        obj.id = -1;
        obj.categoryName = "全部";
        this.classListQuery.push(obj);
        this.classListQuery.push(...res.data.data.list);
        this.classList.push(...res.data.data.list);
      });
    },
    queryDeviceManageList(params) {
      const queryParams = this.buildQueryParams(params);
      if (!queryParams) {
        this.$message.error("所属师傅与分配其他只能选一个");
        return;
      }

      //获取充电桩列表
      this.axios({
        method: "get",
        url: "/v1/web/device-manage/list-device-manage",
        params: queryParams,
      }).then((res) => {
        this.tableData = res.data.data.list;
        this.total = res.data.data.total;
      });
    },
    queryUserList() {
      //获取师傅下拉
      this.axios({
        method: "get",
        url: "/v1/web/user-info/select-master-drown",
      }).then((res) => {
        this.userList = [];
        // let obj = {}
        // obj.id = "";
        // obj.userName = "全部"
        // this.userList.push(obj)
        for (let i = 0; i < res.data.data.list.length; i++) {
          let userInfo = res.data.data.list[i].userName;
          userInfo = userInfo.substring(0, userInfo.indexOf("("));
          res.data.data.list[i].userName = userInfo;
          this.userList.push(res.data.data.list[i]);
        }
      });
    },
    queryAllUserList() {
      this.axios({
        method: "get",
        url: "/v1/web/user-info/select-user-drown",
      }).then((res) => {
        this.allUserList = res.data.data.list || [];
      });
    },
    add() {
      //新增弹出层
      this.dialogFormAdd = true;
      this.isAddBatch = false;
      this.deviceManageArray = {};
      // 清除表单验证状态
      this.$nextTick(() => {
        if (this.$refs.deviceManageArray) {
          this.$refs.deviceManageArray.clearValidate();
        }
      });
    },
    addBatch() {
      //新增弹出层
      this.dialogFormAdd = true;
      this.isAddBatch = true;
      this.deviceManageArray = {};
      // 清除表单验证状态
      this.$nextTick(() => {
        if (this.$refs.deviceManageArray) {
          this.$refs.deviceManageArray.clearValidate();
        }
      });
    },
    addClick(formName) {
      if (this.isAddBatch) {
        let tmpArr = this.deviceManageArray.deviceNums.split(/[(\r\n)\r\n]+/);
        let numList = [];
        for (let i = 0; i < tmpArr.length; i++) {
          let item = tmpArr[i];
          if (!item || !item.replace(/[\t\r\f\n\s]*/g, "")) {
            continue;
          }
          numList.push(item.replace(/[\t\r\f\n\s]*/g, ""));
        }

        console.log(numList);
        this.deviceManageArray.count = numList.length;
        if (this.isRepeat(numList)) {
          this.$message.error("存在重复的充电桩编号");
          return;
        }
        let tips = "".concat(
          "当前输入的充电桩编号有",
          numList.length,
          "个,具体为:",
          numList.join(",\r\n"),
          ",\r\n是否确认?"
        );
        this.$confirm(tips, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.deviceManageArray.deviceNumList = numList;
            this.addSubMit(formName);
          })
          .catch(() => {});
      } else {
        this.addSubMit(formName);
      }
    },
    addSubMit(formName) {
      //新增提交
      if (
        this.deviceManageArray.deviceNum != null &&
        this.deviceManageArray.deviceNum != ""
      ) {
        this.deviceManageArray.count = 1;
      }

      this.$refs[formName].validate((valid) => {
        if (!valid) {
          return false;
        }
        const requestCount = this.deviceManageArray.count;
        this.axios({
          method: "post",
          url: "/v1/web/device-manage/add-device-manage",
          data: this.deviceManageArray,
        })
          .then((res) => {
            const errorReason = this.getDeviceAddErrorReason(res.data);
            if (res.data.code === 200) {
              const successCount = Number(res.data.data);
              if (Number.isNaN(successCount) || successCount !== Number(requestCount)) {
                const reasonText = errorReason ? errorReason : "未全部导入";
                this.$message.error(`导入失败：请求 ${requestCount} 条，${reasonText}`);
                return;
              }
              this.dialogFormAdd = false;
              this.$message.success(`导入成功，共 ${successCount} 条`);
              this.queryDeviceManageList();
              this.$nextTick(() => {
                if (this.$refs.deviceManageArray) {
                  this.$refs.deviceManageArray.clearValidate();
                }
              });
              return;
            }
            this.$message.error(errorReason || "操作失败");
          })
          .catch(() => {
            this.$message.error("网络异常，请稍后重试");
          });
      });
    },
    edit(row) {
      //修改弹出层
      this.deviceManageArray = { ...row };
      console.log(this.deviceManageArray);
      let urlArr = [];
      this.deviceManageArray.imageList = [];
      if (this.deviceManageArray.imageUrl !== null) {
        urlArr = this.deviceManageArray.imageUrl.split(",");
        for (let i = 0; i < urlArr.length; i++) {
          let imgObj = { name: "充电桩图片" + i, url: this.changeImageUrl(urlArr[i]) };
          this.deviceManageArray.imageList.push(imgObj);
        }
      }

      this.dialogFormEdit = true;
    },
    editSubMit(formName) {
      //修改提交
      if (
        this.deviceManageArray.imageList != null &&
        this.deviceManageArray.imageList.length > 0
      ) {
        let urlArr = [];
        for (let i = 0; i < this.deviceManageArray.imageList.length; i++) {
          let image = this.deviceManageArray.imageList[i];
          urlArr.push(this.resetImageUrl(image.url));
        }
        this.deviceManageArray.imageUrl = urlArr.join(",");
      }

      this.$refs[formName].validate((valid) => {
        if (!valid) {
          return false;
        } else {
          this.axios({
            method: "post",
            url:
              "/v1/web/device-manage/update-device-manage/" + this.deviceManageArray.id,
            data: this.deviceManageArray,
          }).then((res) => {
            if (res.data.code === 200) {
              this.dialogFormEdit = false;
              this.$message({ message: "修改成功", type: "success" });
              this.queryDeviceManageList();
            } else {
              this.$message.error(this.getDeviceAddErrorReason(res.data) || "操作失败");
            }
          });
        }
      });
    },
    deleteDevice(row) {
      //删除充电桩
      this.axios({
        method: "delete",
        url: "/v1/web/device-manage/delete-device-manage/" + row.id,
        params: {
          id: row.id,
        },
      }).then((res) => {
        if (res.data.code === 200) {
          this.$message({ message: "已成功删除 1 个充电桩", type: "success" });
          this.queryDeviceManageList();
        } else {
          this.$message({ type: "error", message: res.data.message });
        }
      });
    },
    parseBatchDeviceNums(text) {
      if (!text || !String(text).trim()) {
        return [];
      }
      const nums = String(text)
        .trim()
        .split(/[\s,，]+/)
        .map((item) => item.trim())
        .filter(Boolean);
      return [...new Set(nums)];
    },
    batchDelete() {
      this.batchDeleteDeviceNums = "";
      this.batchDeleteQueryResults = [];
      this.dialogFormBatchDelete = true;
    },
    clearBatchDeleteData() {
      this.batchDeleteDeviceNums = "";
      this.batchDeleteQueryResults = [];
      this.$message.success("已清空");
    },
    queryBatchDeleteDevices() {
      const deviceNums = this.parseBatchDeviceNums(this.batchDeleteDeviceNums);
      if (deviceNums.length === 0) {
        this.$message.error("请输入充电桩编号");
        return;
      }

      if (deviceNums.length > 300) {
        this.$message.error(`单次最大删除数量300，目前${deviceNums.length}个，请删除超出部分`);
        return;
      }

      this.queryBatchDeleteLoading = true;
      this.axios({
        method: "get",
        url: "/v1/web/device-manage/list-device-manage",
        params: {
          page: 1,
          size: 1999,
          deviceNumList: deviceNums.join(",")
        }
      }).then(res => {
        this.queryBatchDeleteLoading = false;
        if (res.data.code === 200) {
          this.batchDeleteQueryResults = res.data.data.list || [];
          const foundNums = this.batchDeleteQueryResults.map(item => item.deviceNum);
          const notFoundNums = deviceNums.filter(num => !foundNums.includes(num));
          if (notFoundNums.length > 0) {
            this.$message.warning(`未找到以下充电桩编号：${notFoundNums.join("、")}`);
          }
        } else {
          this.$message.error(res.data.message || res.data.msg || "查询失败");
        }
      }).catch(err => {
        this.queryBatchDeleteLoading = false;
        this.$message.error("查询失败：" + (err.message || "未知错误"));
      });
    },
    removeBatchDeleteUnavailableDevices() {
      const unavailableDevices = this.batchDeleteQueryResults.filter(
        item => item.status === 1 || item.status === 2
      );

      if (unavailableDevices.length === 0) {
        this.$message.warning("当前没有不可删除的充电桩");
        return;
      }

      const deviceNums = unavailableDevices.map(d => d.deviceNum).join("、");
      this.$confirm(`确定要移除以下不可删除的充电桩吗？\n${deviceNums}`, "移除确认", {
        confirmButtonText: "确认移除",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.batchDeleteQueryResults = this.batchDeleteQueryResults.filter(
          item => item.status !== 1 && item.status !== 2
        );
        this.$message.success(`已移除 ${unavailableDevices.length} 个不可删除的充电桩`);
      }).catch(() => {
        this.$message.info("已取消移除");
      });
    },
    confirmBatchDelete() {
      if (this.batchDeleteQueryResults.length === 0) {
        this.$message.error("请先查询充电桩");
        return;
      }

      const usedDevices = this.batchDeleteQueryResults.filter(item => item.status === 1);
      if (usedDevices.length > 0) {
        this.$message.error(`【${usedDevices.map(d => d.deviceNum).join("、")}】充电桩已使用不允许删除`);
        return;
      }

      const lockingDevices = this.batchDeleteQueryResults.filter(item => item.status === 2);
      if (lockingDevices.length > 0) {
        this.$message.error(`【${lockingDevices.map(d => d.deviceNum).join("、")}】充电桩转借中不允许删除`);
        return;
      }

      const deviceNums = this.batchDeleteQueryResults.map(d => d.deviceNum).join("、");
      this.$confirm(
        `确定要删除以下 ${this.batchDeleteQueryResults.length} 个充电桩吗？\n${deviceNums}`,
        "删除确认",
        {
          confirmButtonText: "确认删除",
          cancelButtonText: "取消",
          type: "warning"
        }
      ).then(() => {
        this.executeBatchDelete();
      }).catch(() => {});
    },
    executeBatchDelete() {
      const deleteCount = this.batchDeleteQueryResults.length;
      this.batchDeleteLoading = true;
      this.axios({
        method: "post",
        url: "/v1/web/device-manage/batch-delete-device-manage",
        data: {
          deviceIdList: this.batchDeleteQueryResults.map(item => item.id)
        }
      }).then((res) => {
        this.batchDeleteLoading = false;
        if (res.data.code === 200) {
          this.dialogFormBatchDelete = false;
          this.$message({ message: `已成功删除 ${deleteCount} 个充电桩`, type: "success" });
          this.queryDeviceManageList();
        } else {
          this.$message.error(res.data.message || "批量删除失败");
        }
      }).catch(err => {
        this.batchDeleteLoading = false;
        this.$message.error("批量删除失败：" + (err.message || "未知错误"));
      });
    },
    batchUpstreamTransfer() {
      this.batchUpstreamTransferDeviceNums = "";
      this.batchUpstreamTransferQueryResults = [];
      this.batchUpstreamTransferForm = { remark: "", attachmentIds: [] };
      this.dialogFormBatchUpstreamTransfer = true;
      this.$nextTick(() => {
        if (this.$refs.batchUpstreamTransferForm) {
          this.$refs.batchUpstreamTransferForm.clearValidate();
        }
        if (this.$refs.upstreamTransferUploadRefs) {
          this.$refs.upstreamTransferUploadRefs.fileList = [];
        }
      });
    },
    clearBatchUpstreamTransferData() {
      this.batchUpstreamTransferDeviceNums = "";
      this.batchUpstreamTransferQueryResults = [];
      this.$message.success("已清空");
    },
    clearBatchUpstreamTransferForm() {
      this.batchUpstreamTransferForm = { remark: "", attachmentIds: [] };
      if (this.$refs.upstreamTransferUploadRefs) {
        this.$refs.upstreamTransferUploadRefs.fileList = [];
      }
    },
    queryBatchUpstreamTransferDevices() {
      const deviceNums = this.parseBatchDeviceNums(this.batchUpstreamTransferDeviceNums);
      if (deviceNums.length === 0) {
        this.$message.error("请输入充电桩编号");
        return;
      }
      if (deviceNums.length > 300) {
        this.$message.error(`单次最大调拨数量300，目前${deviceNums.length}个，请删除超出部分`);
        return;
      }
      this.queryBatchUpstreamTransferLoading = true;
      this.axios({
        method: "get",
        url: "/v1/web/device-manage/list-device-manage",
        params: {
          page: 1,
          size: 1999,
          deviceNumList: deviceNums.join(",")
        }
      }).then(res => {
        this.queryBatchUpstreamTransferLoading = false;
        if (res.data.code === 200) {
          this.batchUpstreamTransferQueryResults = res.data.data.list || [];
          const foundNums = this.batchUpstreamTransferQueryResults.map(item => item.deviceNum);
          const notFoundNums = deviceNums.filter(num => !foundNums.includes(num));
          if (notFoundNums.length > 0) {
            this.$message.warning(`未找到以下充电桩编号：${notFoundNums.join("、")}`);
          }
        } else {
          this.$message.error(res.data.message || res.data.msg || "查询失败");
        }
      }).catch(err => {
        this.queryBatchUpstreamTransferLoading = false;
        this.$message.error("查询失败：" + (err.message || "未知错误"));
      });
    },
    removeBatchUpstreamTransferUnavailableDevices() {
      const unavailableDevices = this.batchUpstreamTransferQueryResults.filter(
        item => item.status === 1 || item.status === 2
      );
      if (unavailableDevices.length === 0) {
        this.$message.warning("当前没有不可调拨的充电桩");
        return;
      }
      const deviceNums = unavailableDevices.map(d => d.deviceNum).join("、");
      this.$confirm(`确定要移除以下不可调拨的充电桩吗？\n${deviceNums}`, "移除确认", {
        confirmButtonText: "确认移除",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.batchUpstreamTransferQueryResults = this.batchUpstreamTransferQueryResults.filter(
          item => item.status !== 1 && item.status !== 2
        );
        this.$message.success(`已移除 ${unavailableDevices.length} 个不可调拨的充电桩`);
      }).catch(() => {
        this.$message.info("已取消移除");
      });
    },
    handleUpstreamTransferUploadSuccess(resData) {
      this.batchUpstreamTransferForm.attachmentIds.push(resData);
    },
    removeUpstreamTransferFile(file, fileList) {
      this.batchUpstreamTransferForm.attachmentIds = fileList.map((item) => item.uid);
    },
    confirmBatchUpstreamTransfer() {
      if (this.batchUpstreamTransferQueryResults.length === 0) {
        this.$message.error("请先查询充电桩");
        return;
      }
      const usedDevices = this.batchUpstreamTransferQueryResults.filter(item => item.status === 1);
      if (usedDevices.length > 0) {
        this.$message.error(`【${usedDevices.map(d => d.deviceNum).join("、")}】充电桩已使用不允许调拨`);
        return;
      }
      const lockingDevices = this.batchUpstreamTransferQueryResults.filter(item => item.status === 2);
      if (lockingDevices.length > 0) {
        this.$message.error(`【${lockingDevices.map(d => d.deviceNum).join("、")}】充电桩转借中不允许调拨`);
        return;
      }
      this.$refs.batchUpstreamTransferForm.validate((valid) => {
        if (!valid) {
          return;
        }
        const deviceNums = this.batchUpstreamTransferQueryResults.map(d => d.deviceNum).join("、");
        this.$confirm(
          `确定要上游调拨以下 ${this.batchUpstreamTransferQueryResults.length} 个充电桩吗？调拨后将从列表移除且不可再操作。\n${deviceNums}`,
          "上游调拨确认",
          {
            confirmButtonText: "确认调拨",
            cancelButtonText: "取消",
            type: "warning"
          }
        ).then(() => {
          this.executeBatchUpstreamTransfer();
        }).catch(() => {});
      });
    },
    executeBatchUpstreamTransfer() {
      const transferCount = this.batchUpstreamTransferQueryResults.length;
      this.batchUpstreamTransferLoading = true;
      this.axios({
        method: "post",
        url: "/v1/web/device-manage/batch-upstream-transfer-device-manage",
        data: {
          deviceIdList: this.batchUpstreamTransferQueryResults.map(item => item.id),
          remark: this.batchUpstreamTransferForm.remark,
          attachmentIds: this.batchUpstreamTransferForm.attachmentIds
        }
      }).then((res) => {
        this.batchUpstreamTransferLoading = false;
        if (res.data.code === 200) {
          this.dialogFormBatchUpstreamTransfer = false;
          const batchNo = res.data.data && res.data.data.batchNo;
          this.$message({
            message: batchNo
              ? `已成功上游调拨 ${transferCount} 个充电桩，批次号：${batchNo}`
              : `已成功上游调拨 ${transferCount} 个充电桩`,
            type: "success",
            duration: 5000
          });
          this.queryDeviceManageList();
        } else {
          this.$message.error(res.data.message || "批量上游调拨失败");
        }
      }).catch(err => {
        this.batchUpstreamTransferLoading = false;
        this.$message.error("批量上游调拨失败：" + (err.message || "未知错误"));
      });
    },
    distributionSubMit(formName) {
      //分配提交
      if (
        this.deviceManageArray.selectDeviceList != null &&
        this.deviceManageArray.selectDeviceList.length > 0
      ) {
        this.deviceManageArray.deviceIdList = [];
        for (let i = 0; i < this.deviceManageArray.selectDeviceList.length; i++) {
          this.deviceManageArray.deviceIdList.push(
            this.deviceManageArray.selectDeviceList[i].id
          );
        }
      }
      // 存储排序数据
      const assignUserId = this.resolveAssignUserId(
        this.deviceManageArray.haveUser,
        this.deviceManageArray.otherUser
      );
      if (!assignUserId) {
        this.$message.error("请选择负责师傅或分配其他");
        return;
      }
      if (this.deviceManageArray.haveUser) {
        saveUserSortSimple(this.deviceManageArray.haveUser, this.sortUserList, STORE_KEY);
        this.sortUserList = getBData(STORE_KEY);
      }
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          return false;
        } else {
          const submitData = {
            ...this.deviceManageArray,
            haveUser: assignUserId,
          };
          delete submitData.otherUser;
          this.axios({
            method: "post",
            url: "/v1/web/device-manage/distribution-device-manage",
            data: submitData,
          }).then((res) => {
            if (res.data.code === 200) {
              this.dialogFormDistribution = false;
              this.$message({ message: "分配成功", type: "success" });
              this.queryDeviceManageList();
              // 清除表单验证状态
              this.$nextTick(() => {
                if (this.$refs.deviceManageArray) {
                  this.$refs.deviceManageArray.clearValidate();
                }
              });
            } else {
              this.$message.error(res.data.message);
            }
          });
        }
      });
    },
    batchDistribution() {
      this.batchDeviceNums = "";
       this.batchQueryResults = [];
      this.dialogFormBatchDistribution = true;
    },
    batchRegionTransfer() {
      this.batchRegionTransferDeviceNums = "";
      this.batchRegionTransferQueryResults = [];
      this.dialogFormBatchRegionTransfer = true;
    },
    clearBatchRegionTransferData() {
      this.batchRegionTransferDeviceNums = "";
      this.batchRegionTransferQueryResults = [];
      this.$message.success("已清空");
    },
    queryBatchRegionTransferDevices() {
      if (!this.batchRegionTransferDeviceNums.trim()) {
        this.$message.error("请输入充电桩编号");
        return;
      }

      const deviceNums = this.batchRegionTransferDeviceNums.trim().split(/\s+/);
      if (deviceNums.length === 0) {
        this.$message.error("请输入有效的充电桩编号");
        return;
      }

      if (deviceNums.length > 300) {
        this.$message.error(`单次最大调拨数量300，目前${deviceNums.length}个，请删除超出部分`);
        return;
      }

      this.queryBatchRegionTransferLoading = true;
      this.axios({
        method: "get",
        url: "/v1/web/device-manage/list-device-manage",
        params: {
          page: 1,
          size: 1999,
          deviceNumList: deviceNums.join(",")
        }
      }).then(res => {
        this.queryBatchRegionTransferLoading = false;
        if (res.data.code === 200) {
          this.batchRegionTransferQueryResults = res.data.data.list || [];
          const foundNums = this.batchRegionTransferQueryResults.map(item => item.deviceNum);
          const notFoundNums = deviceNums.filter(num => !foundNums.includes(num));
          if (notFoundNums.length > 0) {
            this.$message.warning(`未找到以下充电桩编号：${notFoundNums.join("、")}`);
          }
        } else {
          this.$message.error(res.data.msg || "查询失败");
        }
      }).catch(err => {
        this.queryBatchRegionTransferLoading = false;
        this.$message.error("查询失败：" + (err.message || "未知错误"));
      });
    },
    confirmBatchRegionTransfer() {
      if (this.batchRegionTransferQueryResults.length === 0) {
        this.$message.error("请先查询充电桩");
        return;
      }

      const usedDevices = this.batchRegionTransferQueryResults.filter(item => item.status === 1);
      if (usedDevices.length > 0) {
        this.$message.error(`【${usedDevices.map(d => d.deviceNum).join("、")}】充电桩已使用不允许调拨`);
        return;
      }

      const borrowingDevices = this.batchRegionTransferQueryResults.filter(item => item.status === 2);
      if (borrowingDevices.length > 0) {
        this.$message.error(`【${borrowingDevices.map(d => d.deviceNum).join("、")}】充电桩转借中不允许调拨`);
        return;
      }

      this.batchRegionTransferConfirmForm = {
        regionId: undefined,
        masterUserId: "",
        otherUserId: "",
      };
      this.dialogBatchConfirmRegionTransfer = true;
      this.$nextTick(() => {
        if (this.$refs.batchRegionTransferConfirmForm) {
          this.$refs.batchRegionTransferConfirmForm.clearValidate();
        }
      });
    },
    removeRegionTransferUsedDevices() {
      const usedDevices = this.batchRegionTransferQueryResults.filter(item => item.status === 1);

      if (usedDevices.length === 0) {
        this.$message.warning("当前没有已使用的充电桩");
        return;
      }

      const deviceNums = usedDevices.map(d => d.deviceNum).join("、");
      this.$confirm(`确定要删除以下已使用的充电桩吗？\n${deviceNums}`, "删除确认", {
        confirmButtonText: "确认删除",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.batchRegionTransferQueryResults = this.batchRegionTransferQueryResults.filter(item => item.status !== 1);
        this.$message.success(`已删除 ${usedDevices.length} 个已使用的充电桩`);
      }).catch(() => {
        this.$message.info("已取消删除");
      });
    },
    executeBatchRegionTransfer() {
      this.$refs.batchRegionTransferConfirmForm.validate((valid) => {
        if (!valid) {
          return false;
        }

        const assignUserId = this.resolveAssignUserId(
          this.batchRegionTransferConfirmForm.masterUserId,
          this.batchRegionTransferConfirmForm.otherUserId
        );
        if (
          this.batchRegionTransferConfirmForm.masterUserId &&
          this.batchRegionTransferConfirmForm.otherUserId
        ) {
          this.$message.error("负责师傅与分配其他只能选一个");
          return false;
        }

        const transferData = {
          deviceIdList: this.batchRegionTransferQueryResults.map(item => item.id),
          regionId: this.batchRegionTransferConfirmForm.regionId
        };
        if (assignUserId) {
          transferData.haveUser = assignUserId;
        }

        this.batchRegionTransferLoading = true;
        this.axios({
          method: "post",
          url: "/v1/web/device-manage/batch-region-transfer-device-manage",
          data: transferData
        }).then((res) => {
          this.batchRegionTransferLoading = false;
          if (res.data.code === 200) {
            this.dialogFormBatchRegionTransfer = false;
            this.dialogBatchConfirmRegionTransfer = false;
            this.$message({ message: "批量区域调拨成功", type: "success" });
            this.queryDeviceManageList();
          } else {
            this.$message.error(res.data.message);
          }
        }).catch(err => {
          this.batchRegionTransferLoading = false;
          this.$message.error("调拨失败：" + (err.message || "未知错误"));
        });
      });
    },
     clearBatchData() {
       this.batchDeviceNums = "";
       this.batchQueryResults = [];
       this.$message.success("已清空");
     },
     queryBatchDevices() {
       if (!this.batchDeviceNums.trim()) {
         this.$message.error("请输入充电桩编号");
        return;
      }
      
      // 处理输入的充电桩编号，按空格分割
      const deviceNums = this.batchDeviceNums.trim().split(/\s+/);
      if (deviceNums.length === 0) {
        this.$message.error("请输入有效的充电桩编号");
        return;
      }
      
      // 校验编号数量，如果超过300个则提示用户
      if (deviceNums.length > 300) {
        this.$message.error(`单次最大分配数量300，目前${deviceNums.length}个，请删除超出部分`);
        return;
      }
      
      this.queryBatchLoading = true;
       
       // 查询充电桩
      this.axios({
        method: "get",
        url: "/v1/web/device-manage/list-device-manage",
        params: {
          page: 1,
          size: 1999,
          deviceNumList: deviceNums.join(',')
        }
      }).then(res => {
         this.queryBatchLoading = false;
        if (res.data.code === 200) {
           this.batchQueryResults = res.data.data.list || [];
           
           // 获取查询到的充电桩编号
           const foundDeviceNums = this.batchQueryResults.map(item => item.deviceNum);
           
           // 找出未查到的充电桩编号
           const notFoundDeviceNums = deviceNums.filter(num => !foundDeviceNums.includes(num));
           
           if (this.batchQueryResults.length === 0) {
            this.$message.warning("未找到匹配的充电桩");
             return;
           } else {
             this.$message.success(`${deviceNums.length}个编号查询，共查到${this.batchQueryResults.length}个充电桩`);
           }
           
           // 如果有未查到的充电桩编号，显示提示（不自动关闭）
           if (notFoundDeviceNums.length > 0) {
            setTimeout(() => {
              this.$message({
               message: `以下充电桩编号不存在：【${notFoundDeviceNums.join('、')}】`,
               type: 'warning',
               duration: 0, // 不自动关闭
               showClose: true // 显示关闭按钮
             });
            }, 200);
          }
        } else {
          this.$message.error(res.data.msg || "查询失败");
        }
      }).catch(err => {
         this.queryBatchLoading = false;
        this.$message.error("查询失败：" + (err.message || "未知错误"));
      });
    },
    confirmBatchDistribution() {
      if (this.batchQueryResults.length === 0) {
        this.$message.error("请先查询充电桩");
        return;
      }
      
      // 检查充电桩状态 - 已使用的充电桩不允许分配
      const usedDevices = this.batchQueryResults.filter(item => item.status === 1);
      if (usedDevices.length > 0) {
        this.$message.error(`【${usedDevices.map(d => d.deviceNum).join('、')}】充电桩已使用不允许分配`);
        return;
      }
      
      // 检查充电桩状态 - 转借中的充电桩不允许分配
      const borrowingDevices = this.batchQueryResults.filter(item => item.status === 2);
      if (borrowingDevices.length > 0) {
        this.$message.error(`【${borrowingDevices.map(d => d.deviceNum).join('、')}】充电桩转借中不允许分配`);
        return;
      }
      
      // 检查是否同一家公司
      const companyGroups = {};
      this.batchQueryResults.forEach(device => {
        const companyName = device.companyName || '未知公司';
        if (!companyGroups[companyName]) {
          companyGroups[companyName] = [];
        }
        companyGroups[companyName].push(device.deviceNum);
      });
      
      const companyNames = Object.keys(companyGroups);
      if (companyNames.length > 1) {
        // 非同一家公司，需要二次确认
        // 优化显示：使用HTML格式展示每个公司的充电桩
        let confirmMessage = '<div style="text-align: left; line-height: 1.6;">';
        confirmMessage += '<p style="margin: 0 0 15px 0; font-weight: bold;">以下充电桩分属不同公司，是否确认分配？</p>';
        
        companyNames.forEach((company, index) => {
          const deviceNums = companyGroups[company];
          confirmMessage += `<div style="margin-bottom: 15px;">`;
          confirmMessage += `<div style="font-weight: bold; color: #409EFF; margin-bottom: 5px; display: flex; align-items: center; justify-content: space-between;">
            <span>${company} (${deviceNums.length}台充电桩)：</span>
            <button id="copyBtn_${index}" style="padding: 4px 8px; background: #67C23A; color: white; border: none; border-radius: 3px; cursor: pointer; font-size: 12px; margin-left: 10px;">复制所有编号</button>
          </div>`;
          
          // 最多显示10个编号，超出部分用...表示
          const displayNums = deviceNums.slice(0, 10);
          const hasMore = deviceNums.length > 10;
          
          // 如果有更多充电桩，添加tooltip提示
          // 每行显示3个编号，避免过长
          const chunks = [];
          for (let i = 0; i < displayNums.length; i += 3) {
            chunks.push(displayNums.slice(i, i + 3).join('、'));
          }
          
          let displayText = chunks.join('<br/>');
          if (hasMore) {
            displayText += '<br/><span style="color: #909399; font-style: italic;">... 等' + deviceNums.length + '个充电桩</span>';
          }
          
          // 如果有更多充电桩，添加tooltip提示
          if (hasMore) {
            const allNums = deviceNums.join('、');
            confirmMessage += `<div style="color: #606266; font-size: 13px;" title="${allNums}">${displayText}</div>`;
          } else {
            confirmMessage += `<div style="color: #606266; font-size: 13px;">${displayText}</div>`;
          }
          
          confirmMessage += '</div>';
        });
        
        confirmMessage += '</div>';
        
        this.$confirm(confirmMessage, '确认分配', {
          confirmButtonText: '确认分配',
          cancelButtonText: '取消',
          type: 'warning',
          dangerouslyUseHTMLString: true
        }).then(() => {
          this.showUserSelectionDialog();
        }).catch(() => {
          // 用户取消操作
        });
        
        // 延迟添加复制功能，确保DOM已渲染
        this.$nextTick(() => {
          companyNames.forEach((company, index) => {
            const copyBtn = document.getElementById(`copyBtn_${index}`);
            if (copyBtn) {
              const deviceNums = companyGroups[company];
              const allNums = deviceNums.join(' ');  // 使用空格分隔
              copyBtn.onclick = () => {
                navigator.clipboard.writeText(allNums).then(() => {
                  this.$message.success('复制成功！');
                }).catch(() => {
                  this.$message.error('复制失败，请手动复制');
                });
              };
            }
          });
        });
      } else {
        // 同一家公司，直接进入师傅选择
        this.showUserSelectionDialog();
      }
    },
    removeUsedDevices() {
      // 获取已使用的充电桩
      const usedDevices = this.batchQueryResults.filter(item => item.status === 1);
      
      if (usedDevices.length === 0) {
        this.$message.warning("当前没有已使用的充电桩");
        return;
      }
      
      // 确认删除
      const deviceNums = usedDevices.map(d => d.deviceNum).join('、');
      this.$confirm(`确定要删除以下已使用的充电桩吗？\n${deviceNums}`, '删除确认', {
        confirmButtonText: '确认删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 从 batchQueryResults 中删除已使用的充电桩
        this.batchQueryResults = this.batchQueryResults.filter(item => item.status !== 1);
        
        this.$message.success(`已删除 ${usedDevices.length} 个已使用的充电桩`);
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },
    showUserSelectionDialog() {
      this.batchConfirmForm = {
        masterUserId: "",
        otherUserId: "",
      };
      this.dialogBatchConfirmDistribution = true;
    },
    executeBatchDistribution() {
      this.$refs.batchConfirmForm.validate((valid) => {
        if (!valid) {
          return false;
        }

        const assignUserId = this.resolveAssignUserId(
          this.batchConfirmForm.masterUserId,
          this.batchConfirmForm.otherUserId
        );
        if (!assignUserId) {
          this.$message.error("请选择负责师傅或分配其他");
          return false;
        }
        
        this.batchDistributionLoading = true;
        
        const distributionData = {
          deviceIdList: this.batchQueryResults.map(item => item.id),
          haveUser: assignUserId
        };
      this.axios({
        method: "post",
          url: "/v1/web/device-manage/distribution-device-manage",
          data: distributionData
        }).then((res) => {
          this.batchDistributionLoading = false;
          if (res.data.code === 200) {
            // 参考 distributionSubMit 的成功处理
          this.dialogFormBatchDistribution = false;
            this.dialogBatchConfirmDistribution = false;
            this.$message({ message: "批量分配成功", type: "success" });
          this.queryDeviceManageList();
        } else {
            this.$message.error(res.data.message);
        }
      }).catch(err => {
          this.batchDistributionLoading = false;
        this.$message.error("分配失败：" + (err.message || "未知错误"));
        });
      });
    },
    distribution() {
      const hasSelection =
        this.multipleSelection != null && this.multipleSelection.length > 0;
      if (!hasSelection) {
        this.$message({ message: "请选择桩码", type: "error" });
        return;
      }
      this.deviceManageArray = {
        selectDeviceList: [...this.multipleSelection],
        regionId: undefined,
        categoryId: undefined,
        count: undefined,
        haveUser: undefined,
        otherUser: undefined,
      };
      for (let i = 0; i < this.multipleSelection.length; i++) {
        let row = this.multipleSelection[i];
        if (row.status !== 0) {
          this.$message({
            message: "存在状态不为'未使用'的充电桩，不能进行分配",
            type: "error",
          });
          return;
        }
      }

      this.dialogFormDistribution = true;
      // 清除表单验证状态
      this.$nextTick(() => {
        if (this.$refs.deviceManageArray) {
          this.$refs.deviceManageArray.clearValidate();
        }
      });
    },
    unDistribution() {
      //取消分配
      if (this.multipleSelection == null || this.multipleSelection.length <= 0) {
        this.$message({ message: "请选择对应需要取消分配的充电桩", type: "error" });
        return;
      }

      let deviceIdList = [];
      for (let i = 0; i < this.multipleSelection.length; i++) {
        let row = this.multipleSelection[i];
        if (row.status !== 0) {
          this.$message({
            message: "存在状态不为'未使用'的充电桩，不能进行分配",
            type: "error",
          });
          return;
        }

        deviceIdList.push(row.id);
      }

      this.$confirm("是否确定取消分配?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios({
            method: "post",
            url: "/v1/web/device-manage/un-distribution-device",
            data: { deviceIdList: deviceIdList },
          }).then((res) => {
            if (res.data.code === 200) {
              this.dialogFormBorrow = false;
              this.$message({ message: "操作成功", type: "success" });
              this.queryDeviceManageList();
            } else {
              this.$message.error(res.data.message);
            }
          });
        })
        .catch(() => {});
    },
    borrow() {
      this.dialogFormBorrow = true;
      this.deviceManageBorrow = {};
      this.getDeviceByCategory();
    },
    borrowSubMit(formName) {
      //借出提交
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          return false;
        } else {
          this.axios({
            method: "post",
            url: "/v1/web/device-manage/add-device-sub",
            data: this.deviceManageBorrow,
          }).then((res) => {
            if (res.data.code === 200) {
              this.dialogFormBorrow = false;
              this.$message({ message: "转借成功", type: "success" });
              this.queryDeviceManageList();
            } else {
              this.$message.error(res.data.message);
            }
          });
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    dateFormat: function (row, column, cellValue) {
      if (cellValue !== null && cellValue !== undefined) {
        return moment(cellValue).format("YYYY-MM-DD HH:mm:ss");
      }
    },
    statusFormat: function (row) {
      if (row.status === 0) {
        return "未使用";
      } else if (row.status === 1) {
        return "已使用";
      } else if (row.status === 2) {
        return "转借中";
      }
    },
    isBadFormat: function (row) {
      if (row.isBad === 1) {
        return "是";
      } else {
        return "否";
      }
    },
    regionNameFormat: function (row, column, cellValue) {
      if (cellValue == null || cellValue === "") {
        return "-";
      }
      return cellValue;
    },
    handleCurrentChange(val) {
      this.params.page = val;
      this.queryDeviceManageList();
    },
    sizeChange(val) {
      this.params.size = val;
      this.params.page = 1;
      this.queryDeviceManageList();
    },
    toDayList(isCurrentUser) {
      this.params = { page: 1, size: 10 };
      this.recordTime = [];
      this.allocationDate = [];
      if (this.isTodayQuery) {
        this.reset();
        return;
      }
      this.isTodayQuery = true;
      let params = { page: 1, size: 10 };
      if (isCurrentUser) {
        params.distributionUser = Number(sessionStorage.getItem("userId"));
      }

      // 设置今日0点0分0秒时间戳 及 今日23:59:59时间
      params.distributionTime = new Date().setHours(0, 0, 0, 0);
      this.queryDeviceManageList(params);
    },
    checkData() {
      this.isTodayQuery = false;
      if (this.params.categoryId === -1) {
        this.params.categoryId = "";
      }
      this.params.distributionUser = "";
      if (this.params.haveUser && this.params.otherUser) {
        this.$message.error("所属师傅与分配其他只能选一个");
        return;
      }
      this.queryDeviceManageList();
    },
    reset() {
      this.isTodayQuery = false;
      this.params = { page: 1, size: 10 };
      this.recordTime = [];
      this.allocationDate = [];
      this.queryDeviceManageList();
    },
    isRepeat(arr) {
      var hash = {};
      for (var i in arr) {
        if (hash[arr[i]]) {
          return true;
        }
        hash[arr[i]] = true;
      }
      return false;
    },
    getDeviceAddErrorReason(responseData) {
      if (!responseData) {
        return "";
      }
      const message = responseData.message;
      const data = responseData.data;
      if (message === "充电桩已存在" && typeof data === "string" && data) {
        return data.startsWith("充电桩编号已存在：") || data.startsWith("重复充电桩编号:")
          ? data.replace(/^重复充电桩编号:/, "充电桩编号已存在：")
          : `充电桩编号已存在：${data}`;
      }
      if (message && message !== "成功！") {
        return message;
      }
      if (typeof data === "string" && data) {
        return data;
      }
      return "";
    },
    upload(file, fileList) {
      if (fileList.length >= 40) {
        this.$message.error("最多只能上传40张照片");
        return;
      }
      this.clickUpload(file);
    },
    async clickUpload(file) {
      let fileRaw;
      let maxSize = 200 * 1024; //自己定义的文件大小，超过多少M就开始压缩(现在是200k)
      if (file.size > maxSize) {
        fileRaw = await this.compressFile(file.raw, 0.2);
        file.raw = fileRaw;
      }

      this.uploadImage(file);
    },
    uploadImage(file) {
      let obj = {};
      obj.name = file.name;
      let param = new FormData(); //创建form对象
      param.append("files", file.raw);
      param.append("orderNum", this.deviceManageArray.id);
      this.axios({
        method: "post",
        url: "/v1/h5/order-info/image-upload",
        data: param,
      })
        .then((res) => {
          let imgUrl = res.data.data.imageUrl;
          obj.url = this.changeImageUrl(imgUrl);
          this.deviceManageArray.imageList.push(obj);
        })
        .catch((e) => {
          console.log(e);
          this.$message.error("上传失败");
        });
    },
    commRemove(file) {
      let j = 0;
      for (let i = 0; i < this.deviceManageArray.imageList.length; i++) {
        if (file.name === this.deviceManageArray.imageList[i].name) {
          j = i;
        }
      }
      this.deviceManageArray.imageList.splice(j, 1);
    },
    handlePictureCardPreview(file) {
      this.imagePreviewUrl = file.url;
      this.dialogImagePreview = true;
    },
    changeImageUrl(imageUrl) {
      //转换图片路径
      if (imageUrl === null || imageUrl === "") {
        return "#";
      }
      return "/api/v1/web/order-info/preview-image?path=" + imageUrl;
    },
    resetImageUrl(imageUrl) {
      //转换为相对路径
      if (imageUrl === null || imageUrl === "") {
        return "";
      }
      return imageUrl.replace("/api/v1/web/order-info/preview-image?path=", "");
    },
    getImageList(urls) {
      if (urls == null || urls == "") {
        return [];
      }

      let arr = urls.split(",");
      let urlArr = [];
      for (let i = 0; i < arr.length; i++) {
        let url = arr[i];
        urlArr.push(this.changeImageUrl(url));
      }

      return urlArr;
    },
    /**
     * 压缩图片
     * @param file
     * @returns {Promise<unknown>}
     */
    compressFile(file, quality) {
      return new Promise((resolve, reject) => {
        new ImageCompressor(file, {
          quality: quality, //压缩质量
          checkOrientation: false, //图片翻转，默认为false
          success(result) {
            resolve(result);
          },
          error(e) {
            reject(e);
          },
        });
      });
    },
  },
};
</script>

<style scoped>
.batch-region-transfer-btn {
  background-color: #1b4f8a;
  border-color: #1b4f8a;
  color: #fff;
}

.batch-region-transfer-btn:hover,
.batch-region-transfer-btn:focus {
  background-color: #153d6e;
  border-color: #153d6e;
  color: #fff;
}
</style>
